import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoadedGuard } from './shared/guards/loaded.guard';
import { idCallbackGuard } from './auth/id-callback.guard';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsModule),
		canActivate: [LoadedGuard]
	},
	// Printed table QR (places/helpers/table-code.ts): the place page asks whether to check in or
	// start a match on that table.
	{
		path: 't/:placeId/:table',
		redirectTo: ({ params }) => `/tabs/places/detail/${params['placeId']}?table=${params['table']}`
	},
	// Pro Pool ID's redirect back to the web build after login (ID-5). Native apps use a custom scheme instead.
	{
		path: 'auth/callback',
		canActivate: [idCallbackGuard],
		children: []
	},
	// Catches unmatched URLs (e.g. a stale PWA shortcut's start_url) so they recover to the app
	// instead of crashing to a blank screen with an uncaught NG04002.
	{
		path: '**',
		redirectTo: ''
	}
];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules
        })
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
